ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.StepHandler extends Handler

    # inputSel should be overridden in the child class
    inputSel: 'input'


    init: () ->
        @layoutID = '#spp_body'
        @layoutSelector = @parent.dialog.find(@layoutID)
        @sidebar = @parent.parent

        @inputChanged = false
        @firstLoad = true

        if @response?.view?
            @layoutSelector.html(@response.view)

            # run afterLoadLayout after the current execution stack finishes
            setTimeout () =>
                @afterLoadLayout(@layoutSelector, @response)

        else
            @layoutUrl = 'backend/grower/placement/spp/load-step'
            @loadLayoutPostOptions =
                id: @parent.sppID
                result_id: @parent.resultID
                step_id: @id

            @loadLayout()


    moveStepContent: () ->
        header = @layoutSelector.find '.spp_header'
        $('#spp_header').empty().append header

        footer = @layoutSelector.find '.spp_footer'
        $('#spp_footer').empty().append footer

        stepFooter = @layoutSelector.find '.spp_step_footer'
        $('#spp_step_footer').remove()
        if stepFooter.length
            modalBody = $('#spp_body').closest '.modal-body'
            $('<div id="spp_step_footer"></div>').insertAfter(modalBody).append stepFooter


    afterLoadLayout: (sel, response) ->
        # if we get an error response (e.g., validation), we can still
        # continue, but we can't do anything for an invalid response
        if not response.status?.type?
            return

        # we are basically writing our own afterLoadLayout() method here
        @moveStepContent()
        @parent._handleResize()
        @validator = new ValidationEngine()

        # Anytime any input changes we set @inputChanged.
        # We could be fancier and check if the value is different than when we
        # loaded the step, but that would take some more time. This is easy.
        @getInputEl().on 'change', () =>
            @inputChanged = true

        # set the next and back button click handlers
        @parent.dialog.find('#back_button').on 'click', () =>
            @parent.goToStep(@num - 1)

        @parent.dialog.find('#next_button').on 'click', () =>
            @toStep = @num + 1
            # validator calls goToStep() if the form validates
            @validator.validateAll()

        # call customAfterLoadLayout if it exists
        @customAfterLoadLayout?()

        # initialize the message writer
        @msg = $(@parent.layoutSelector).find('.message_writer').message_writer(autoHide: false, hideTime: 10000)

        # restore any saved values
        @applyFieldsAspects()

        # set the display name
        @display_name = @parent.taffyObjects.steps().filter(id: @id).first().display_name

        # set up validation
        @validator.makeFormValidator 'placement', '.validationContainer', '.errorDiv', (valid) =>
            if valid
                @parent.goToStep(@toStep)

        @addValidationRules()

        # update the step progress
        @sidebar.stepListKO.setCurrent @id

        # autofocus on the first input
        @getInputEl().first().focus()


    applyFieldsAspects: () ->
        # use the fieldsAspects taffy object to set the input values

        # create a few aliases b/c we use these a lot
        stepFields = @taffyObjects.fields
        sppFields = @parent.taffyObjects.fields
        fieldsAspects = @parent.taffyObjects.fieldsAspects

        stepAspects = @getStepAspects()

        if @num is 1 and stepAspects().count() > 0
            # special handling for the Operator Selection step
            field = sppFields().first()
            aspect = stepAspects().first()

            field_aspect =
                fields_id: field.id
                aspects_id: aspect.aspects_id
                value: @parent.operators_id

            @setFieldAspect field_aspect

        else if stepAspects().count() > 0
            stepFields().each (field) =>
                stepAspects().each (aspect) =>
                    fieldAspect = fieldsAspects(fields_id: field.id, aspects_id: aspect.aspects_id).last()
                    if not fieldAspect? then return

                    @setFieldAspect fieldAspect

        else
            sppFields().each (field) =>
                @setFieldAspect field


    updateFieldsAspects: () ->
        # store the fieldsAspects in the Taffy DB

        # create a few aliases b/c we use these a lot
        stepAspects = @getStepAspects()

        stepFields = @taffyObjects.fields
        sppFields = @parent.taffyObjects.fields
        fieldsAspects = @parent.taffyObjects.fieldsAspects

        # delete the old fieldsAspects affected by this step
        stepAspects().each (stepAspect) =>
            fieldsAspects(aspects_id: stepAspect.aspects_id).remove()

        if @num is 1 and stepAspects().count() > 0
            # special handling for the Operator Selection step
            # Save to the survey result itself because none of the fields have
            # been selected yet.
            field = sppFields().first()
            stepAspect = stepAspects().first()

            result = @getFieldAspect field.id, stepAspect.aspects_id

            if result.value?
                @parent.operators_id = result.value
                @parent.operator_name = result.option_name
            else
                @parent.operators_id = null
                @parent.operator_name = null


        else if stepAspects().count() > 0
            # insert the new fieldsAspects
            sppFields(selected: true).each (field) =>

                # if the field is not in stepFields, then save the input but don't
                # do anything with it
                skip = not stepFields(id: field.id).count()
                stepAspects().each (stepAspect) =>

                    # include pretty names, but only aspect_name is ever used
                    defaultResult =
                        fields_id: field.id
                        field_name: field.display_name
                        aspects_id: stepAspect.aspects_id
                        aspect_name: stepAspect.aspect_name
                        display_name: stepAspect.display_name
                        value: null
                        options_id: null
                        option_name: null
                        skip: skip
                        steps_id: @id
                        step_name: @display_name

                    result = @getFieldAspect field.id, stepAspect.aspects_id
                    fieldsAspects.insert $.extend defaultResult, result

        else if @num is 1 or @num is 2

            # If there are no stepAspects and this is the first or second step,
            # then this is a field selection step, and we should only set the
            # field's selected attribute.

            # TODO: find a better way of check for the field selection step
            # NO KIDDING 2012 SEAN! It took forever to find this!
            fieldNum = 0
            markVisitedSteps = false
            sppFields().each (field) =>
                if @getFieldAspect field.id
                    # If we are adding a new field that wasn't there before, mark all subsequent steps as not visited
                    if not sppFields(id: field.id).first().selected
                        markVisitedSteps = true

                    sppFields(id: field.id).update
                        selected: true
                        field_num: fieldNum++
                else
                    sppFields(id: field.id).update
                        selected: false
                        field_num: null

            if markVisitedSteps
                # Update the steps in the frontend
                for step in @parent.taffyObjects.steps().get()
                    if step.step_order > @num
                        step.visited false

                # Update the steps in the backend
                $.post 'backend/grower/placement/spp/mark-highest-visited-step',
                    result_id: @parent.resultID
                    step_id: @num

        # else do nothing


    getStepAspects: () ->
        # return the aspects that are affected by this step in a Taffy object

        # Prefer the Y axis over X, because if X and Y are both aspects,
        # X will likely just contain options to choose for the Y aspects.

        yArray = @taffyObjects.axes(name: 'Y').first().array
        if yArray is 'y_aspects' then return @taffyObjects.y_aspects

        xArray = @taffyObjects.axes(name: 'X').first().array
        if xArray is 'x_aspects' then return @taffyObjects.x_aspects

        return new TAFFY()


    addValidationRules: () ->
        # this method is a stub
        return

    setFieldAspect: (fieldAspect) ->
        # this method is a stub
        return

    getFieldAspect: (fieldID, aspectID) ->
        # this method is a stub
        return {}


    getInputEl: (dataAttrs = {}) ->
        # utility function used in @getFieldAspect and @setFieldAspect

        # grabs the jQuery object matching the supplied data attributes (+step)
        # e.g. if
        #   dataAttrs is { field:123, aspect:42 }
        #   @inputSel is 'select'
        #   @num is 15
        #
        # we'll do:
        #   @layoutSelector.find('select[data-step="15"][data-field="123"][data-aspect="42"]')

        # always add the step to the data attrs to select on
        dataAttrs.step = @num

        dataAttrStr = ''
        for attr, val of dataAttrs
            dataAttrStr += "[data-#{attr}=\"#{val}\"]"

        return @layoutSelector.find(@inputSel + dataAttrStr)
